var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.documents
    ? _c(
        "div",
        _vm._l(_vm.documents, function(document, idx) {
          return _c(
            "div",
            { key: `type-${idx}-${document.documentFilename}` },
            [
              _vm.specialistLicensefileUploadVisibility(
                document.specialistLicenseDocumentTypeId
              )
                ? _c(
                    "div",
                    {
                      staticClass: "bg-secondary-3 mt-4 rounded p-4",
                      class: { "bg-white": !_vm.isEditing }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "row pt-3",
                          staticStyle: { "border-top": "1px solid #eee" }
                        },
                        [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("label", { staticClass: "data-title mb-0" }, [
                              _vm._v("Tipo de documento:")
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("empty")(
                                    document.specialistLicenseDocumentTypeName
                                  )
                                )
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-md-4" },
                            [
                              _c("label", { staticClass: "data-title mb-0" }, [
                                _vm._v("Archivo:")
                              ]),
                              document.documentId || document.guid
                                ? _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(
                                            document.documentFilename
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _c("validation-provider", {
                                    attrs: {
                                      name: `specialistLicensefileUploadRef${document.specialistLicenseDocumentTypeId}`
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-file-input", {
                                                ref: `specialistLicensefileUploadRef${document.specialistLicenseDocumentTypeId}`,
                                                refInFor: true,
                                                attrs: {
                                                  accept: _vm.allowedFiles,
                                                  "accept-terms-modal-title":
                                                    "Certificación",
                                                  "accept-terms-text":
                                                    "Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)",
                                                  "accept-terms-title":
                                                    "Acepto los términos y responsabilidades",
                                                  "accept-terms-validation-msg":
                                                    "Favor certifique el documento  que ha subido al sistema REMpro.",
                                                  "allow-accept-terms": "",
                                                  "attachment-id":
                                                    document.documentId,
                                                  "custom-error-msg": _vm.specialistLicenseCustomError(
                                                    document.specialistLicenseDocumentTypeId
                                                  ),
                                                  "display-style": "normal",
                                                  error: errors[0],
                                                  "label-position": "left",
                                                  "on-download":
                                                    _vm.onDownloadFile,
                                                  value: document.attachment
                                                },
                                                on: {
                                                  input: file =>
                                                    _vm.onChangeFile(
                                                      file,
                                                      document
                                                    )
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                            ],
                            1
                          ),
                          document.documentId || document.guid
                            ? _c("div", { staticClass: "col-md-2 pl-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "mt-3" },
                                  [
                                    _c("action-button", {
                                      staticClass:
                                        "mr-2 border-green document-button-icon",
                                      attrs: {
                                        i:
                                          "fas fa-file-download text-green mr-n1 pr-1"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadDocument(document)
                                        }
                                      }
                                    }),
                                    _c("action-button", {
                                      staticClass:
                                        "border-danger document-button-icon",
                                      attrs: {
                                        i:
                                          "fas fa-times-circle text-red mr-n1 pr-1"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteDocument(document)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          document.specialistLicenseDocumentTypeId ===
                            _vm.specialistLicenseDocumentTypes
                              .CertForCyberTherapy &&
                          (document.documentId || document.guid)
                            ? _c("div", { staticClass: "col-md pl-0 pr-1" }, [
                                _c(
                                  "label",
                                  { staticClass: "data-title mb-0" },
                                  [_vm._v("Fecha de Expiración:")]
                                ),
                                document.guid
                                  ? _c(
                                      "div",
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "licenseDueDate",
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("custom-date-picker", {
                                                      attrs: {
                                                        "class-container":
                                                          "w-100",
                                                        "custom-error-msg":
                                                          "La fecha de expiración es requerida.",
                                                        error: errors[0],
                                                        format: "dd/MMM./yyyy",
                                                        "min-date":
                                                          _vm.currentDate
                                                      },
                                                      model: {
                                                        value:
                                                          document.licenseDocumentExpiryDate,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            document,
                                                            "licenseDocumentExpiryDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "document.licenseDocumentExpiryDate"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                document.documentId
                                  ? _c("div", [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("date")(
                                                document.licenseDocumentExpiryDate
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }